"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const createTheme = ({
  color
}) => {
  const backgroundColor = (0, _color.default)(color);

  if (backgroundColor.isDark()) {
    return (0, _styles.createMuiTheme)({
      palette: {
        type: "dark",
        background: {
          default: backgroundColor.hex()
        }
      }
    });
  }

  return (0, _styles.createMuiTheme)({
    palette: {
      background: {
        default: backgroundColor.hex()
      }
    }
  });
};

const SectionTheme = (_ref) => {
  let children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#f5f5f5" : _ref$color,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "color"]);

  let theme;

  if (color === "dark") {
    theme = (0, _styles.createMuiTheme)({
      palette: {
        type: "dark"
      }
    });
  } else if (color) {
    theme = createTheme({
      color
    });
  }

  return _react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, children);
};

var _default = SectionTheme;
exports.default = _default;
module.exports = exports.default;